import api from "./baseApi";
import { stringifyParamsWithArrays } from "common/utils/stringHelper";

const UPLOAD_TIMEOUT_MS = 120000;

export const branchApi = {
  upload: (officeCd, file) => {
    const formData = new FormData();
    formData.append("office_cd", officeCd);
    formData.append("file", file);
    return api.post("/branches/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: UPLOAD_TIMEOUT_MS,
    });
  },

  listByOffices: (officeCds) =>
    api.get("/branches", {
      params: { office_cds: officeCds || [] },
      paramsSerializer: (p) => stringifyParamsWithArrays(p),
    }),

  download: (officeCd) =>
    api.get("/branches/download", {
      params: { office_cd: officeCd },
      responseType: "blob",
    }),
};
